import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdateResidentResource = async (
  projectId,
  manualResourceId,
  updateAttributes
) => {
  const apiPath = `projects/${projectId}/resource/${manualResourceId}/update-resident-resource`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: updateAttributes,
  });

  const response = await axios(signedRequest);

  return response.data;
};
